import React from "react";

function CircleIcon({ ...props }) {
  return (
    <>
      <img
        src="https://cdn1.iconfinder.com/data/icons/material-core/20/check-circle-outline-blank-1024.png"
        alt="circle"
        {...props}
      />
    </>
  );
}

export default CircleIcon;
